export default [
    {
        title: "mainmenu.contacts",
        route: "contacts",
        icon: "address-book",
        resource: "contactsNavMenu",
        action: "read",
    },
];
